module.exports = __webpack_public_path__ + "img/iot-management.186d12f9.svg";